var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "card-box", class: _vm.setCardClass(_vm.item.gradeType) },
      [
        _c("div", { staticClass: "top" }, [
          _c("div", { staticClass: "top-left" }, [
            _vm._v(_vm._s(_vm.item.roleCodeName)),
          ]),
          _c("div", { staticClass: "top-right" }, [
            _c("span", {
              staticStyle: {
                display: "inline-block",
                width: "6px",
                height: "6px",
                "border-radius": "50%",
                position: "absolute",
                top: "4px",
                left: "-10px",
              },
              style: {
                background: _vm.formattStatus(_vm.item.auditStatus, "color"),
              },
            }),
            _c("span", [
              _vm._v(_vm._s(_vm.formattStatus(_vm.item.auditStatus, "status"))),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "span",
              [
                _c("icon-svg", {
                  staticClass: "icon-color",
                  attrs: { name: "user" },
                }),
              ],
              1
            ),
            _c("span", { staticClass: "name" }, [_vm._v("提交人")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm._f("projectIsEmpty")(_vm.item.auditorName))),
            ]),
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "span",
              [
                _c("icon-svg", {
                  staticClass: "icon-color",
                  attrs: { name: "createTime" },
                }),
              ],
              1
            ),
            _c("span", { staticClass: "name" }, [_vm._v("创建时间")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm._f("projectIsEmpty")(_vm.item.startTime))),
            ]),
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "span",
              [
                _c("icon-svg", {
                  staticClass: "icon-color",
                  attrs: { name: "submitTime" },
                }),
              ],
              1
            ),
            _c("span", { staticClass: "name" }, [_vm._v("提交时间")]),
            _c("span", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm._f("projectIsEmpty")(_vm.item.endTime))),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "bottom" }, [
          _vm.item.costTimes && _vm.item.limitTime
            ? _c("div", {
                staticClass: "progress",
                style: {
                  width:
                    (Number(_vm.item.costTimes) /
                      Number(_vm.item.limitTime * 60)) *
                      100 +
                    "%",
                },
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "progressTitle",
              style: { "justify-content": _vm.item.limitTime ? "flex" : "" },
            },
            [
              _vm.item.costTimes
                ? _c(
                    "div",
                    {
                      style: {
                        "margin-left": _vm.item.progressValue,
                        "margin-right": "10px",
                      },
                    },
                    [
                      _vm._v(
                        "历时： " + _vm._s(_vm.formattSec(_vm.item.costTimes))
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.item.limitTime
                ? _c("div", [
                    _vm._v("限时： " + _vm._s(_vm.item.limitTime) + "分钟"),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
        _vm._m(0),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bg" }, [
      _c("img", {
        attrs: {
          src: require("../../../../../assets/img/bgCard.png"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }